import { render, staticRenderFns } from "./CourierSupplierShipmenList.vue?vue&type=template&id=fd3299ea&scoped=true&"
import script from "./CourierSupplierShipmenList.vue?vue&type=script&lang=js&"
export * from "./CourierSupplierShipmenList.vue?vue&type=script&lang=js&"
import style0 from "./CourierSupplierShipmenList.vue?vue&type=style&index=0&id=fd3299ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3299ea",
  null
  
)

export default component.exports